<div class="mt-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <div class="bg-white shadow rounded p-5">
          <div class="text-center">
            <img src="../../../assets/alt_logo.png" class="w-25 mt-3">
          </div>

          <h4 class="text-center mt-3">Change Password</h4>

          @if (!isPasswordChanged) {
            <div>
              <div class="form-group mt-3">
                <label class="form-label required" for="currentPassword">Current Password</label>
                <div class="input-group">
                  <input [type]="currentPasswordType" class="form-control" id="currentPassword"
                    [(ngModel)]="currentPassword" name="currentPassword" required>
                  <span class="input-group-text pointer" (click)="onShowPassword('current')">
                    <i class="bi" [ngClass]="showCurrentPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
              </div>
              <div class="form-group mt-3">
                <label class="form-label required" for="newPassword">New Password</label>
                <div class="input-group">
                  <input [type]="newPasswordType" class="form-control" id="newPassword"
                    [(ngModel)]="newPassword" name="newPassword" required>
                  <span class="input-group-text pointer" (click)="onShowPassword('new')">
                    <i class="bi" [ngClass]="showNewPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
                @if (newPassword) {
                  <div class="mt-2">
                    <small class="d-block" [class.text-success]="newPassword.length >= 12" [class.text-muted]="newPassword.length < 12">
                      <i class="bi" [class.bi-check]="newPassword.length >= 12" [class.bi-x]="newPassword.length < 12"></i> At least 12 characters
                    </small>
                    <small class="d-block" [class.text-success]="hasUpperCase(newPassword)" [class.text-muted]="!hasUpperCase(newPassword)">
                      <i class="bi" [class.bi-check]="hasUpperCase(newPassword)" [class.bi-x]="!hasUpperCase(newPassword)"></i> 1 uppercase letter
                    </small>
                    <small class="d-block" [class.text-success]="hasLowerCase(newPassword)" [class.text-muted]="!hasLowerCase(newPassword)">
                      <i class="bi" [class.bi-check]="hasLowerCase(newPassword)" [class.bi-x]="!hasLowerCase(newPassword)"></i> 1 lowercase letter
                    </small>
                    <small class="d-block" [class.text-success]="hasNumber(newPassword)" [class.text-muted]="!hasNumber(newPassword)">
                      <i class="bi" [class.bi-check]="hasNumber(newPassword)" [class.bi-x]="!hasNumber(newPassword)"></i> 1 number
                    </small>
                    <small class="d-block" [class.text-success]="hasSpecialChar(newPassword)" [class.text-muted]="!hasSpecialChar(newPassword)">
                      <i class="bi" [class.bi-check]="hasSpecialChar(newPassword)" [class.bi-x]="!hasSpecialChar(newPassword)"></i> 1 special character
                    </small>
                  </div>
                }
              </div>
              <div class="form-group mt-3">
                <label class="form-label required" for="confirmPassword">Confirm Password</label>
                <div class="input-group">
                  <input [type]="confirmPasswordType" class="form-control" id="confirmPassword"
                    [(ngModel)]="confirmPassword" name="confirmPassword" required>
                  <span class="input-group-text pointer" (click)="onShowPassword('confirm')">
                    <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                  </span>
                </div>
                @if (confirmPassword && newPassword !== confirmPassword) {
                  <div class="text-danger mt-1">
                    Passwords do not match
                  </div>
                }
              </div>
              <button class="btn btn-warning w-100 mt-4"
                [disabled]="!currentPassword || !newPassword || !confirmPassword || newPassword !== confirmPassword || !isPasswordValid(newPassword)"
              (click)="resetPassword()">Change Password</button>
            </div>
          }

          @if (isPasswordChanged) {
            <div class="text-center mt-4">
              <p class="text-success fw-bold">Password changed successfully!</p>
              <a routerLink="/app" class="btn btn-link">Back to Dashboard</a>
            </div>
          }

          @if (errorMessage) {
            <div class="mt-3">
              <ngb-alert type="danger" (closed)="errorMessage = '' ">{{ errorMessage }}</ngb-alert>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>